import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AuthLayout } from 'src/layouts/auth/AuthLayout';

import { SplashScreen } from 'src/components/LoadingScreen';

const UnauthorizedPage = lazy(() => import('src/pages/auth/unauthorized'));
const CreateProcurer = lazy(() => import('src/pages/auth/Create/Procurer'));
const CreateProcurerSuccess = lazy(() => import('src/pages/auth/Create/CreateProcurerSuccess'));

export const authRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'unauthorized',
        element: (
          <AuthLayout>
            <UnauthorizedPage />
          </AuthLayout>
        ),
      },
      {
        path: 'create/procurer',
        element: (
          <AuthLayout>
            <CreateProcurer />
          </AuthLayout>
        ),
      },
      {
        path: 'create/procurer/success',
        element: (
          <AuthLayout>
            <CreateProcurerSuccess />
          </AuthLayout>
        ),
      },
    ],
  },
];
